import React from 'react';
import ToolbarIcon from './ToolbarIcon';

export const IconMail = (props) => (
  <ToolbarIcon viewBox="0 0 64 64" {...props}>
    <path d="m62.511,12.796s0-.002,0-.002c-.972-2.367-3.297-4.041-6.009-4.041H7.497c-2.714.002-5.038,1.68-6.009,4.051,0,.002,0,.003-.002.005-.309.756-.486,1.579-.487,2.444v33.508c.002,1.735.677,3.366,1.905,4.589,1.226,1.223,2.854,1.898,4.587,1.898h49.008c3.581-.002,6.497-2.916,6.5-6.497V15.252c0-.87-.178-1.697-.489-2.456ZM5.51,50.73c-.529-.529-.818-1.231-.816-1.98v-31.713l24.879,21.265c.67.578,1.527.897,2.414.897h.012v-.002c.902.025,1.742-.314,2.41-.89l24.896-21.273v31.717c-.005,1.545-1.263,2.8-2.805,2.802H7.482c-.746,0-1.446-.292-1.972-.823Zm26.487-12.166h0Zm-.017-3.067L5.778,13.098c.48-.384,1.062-.649,1.721-.651h49.006c.659.001,1.24.265,1.718.648l-26.243,22.402Z" />
  </ToolbarIcon>
);

export default IconMail;
